import React, { useEffect, useState } from "react";
import { api, formatApiError, STATUS_LABELS, STATUS_CHIP } from "../lib/apiClient";
import { PageHeader } from "../components/Layout";
import { toast } from "sonner";

const FILTERS = [
  { key: "", label: "Tümü" },
  { key: "URETIM_BEKLIYOR", label: "Üretime Hazır" },
  { key: "URETIMDE", label: "Üretimde" },
  { key: "HAZIR", label: "Hazır" },
  { key: "SEVK_EDILDI", label: "Sevk Edildi" },
];

export default function ProductionPage() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/pieces", { params: filter ? { status_filter: filter } : {} });
        setRows(data);
      } catch (e) { toast.error(formatApiError(e)); }
      setLoading(false);
    })();
  }, [filter]);

  const filtered = rows.filter(r =>
    !q ||
    r.barcode.toLowerCase().includes(q.toLowerCase()) ||
    r.order_number.toLowerCase().includes(q.toLowerCase()) ||
    r.customer_name.toLowerCase().includes(q.toLowerCase()) ||
    r.model.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div>
      <PageHeader title="Üretim Takibi" subtitle="Tüm fiziksel parçalar ve mevcut durumları" />

      <div className="flex flex-wrap gap-2 mb-4">
        {FILTERS.map(f => (
          <button
            key={f.key}
            data-testid={`filter-${f.key || "all"}`}
            onClick={() => setFilter(f.key)}
            className={`px-4 py-2 border-2 font-bold text-sm uppercase tracking-wide ${filter === f.key ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-300 text-slate-700 hover:border-slate-800"}`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <input
        data-testid="prod-search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Barkod, sipariş no, müşteri, model ara..."
        className="w-full max-w-md mb-4 px-4 py-3 bg-white border border-slate-300 rounded-none focus:border-blue-700 focus:outline-none"
      />

      <div className="card-industrial overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-slate-100 border-b border-slate-300 text-xs uppercase tracking-widest text-slate-600">
              <th className="text-left px-4 py-3">Barkod</th>
              <th className="text-left px-4 py-3">Sipariş</th>
              <th className="text-left px-4 py-3">Müşteri</th>
              <th className="text-left px-4 py-3">Ürün</th>
              <th className="text-left px-4 py-3">Ölçü</th>
              <th className="text-left px-4 py-3">Ürün#</th>
              <th className="text-left px-4 py-3">Parça#</th>
              <th className="text-left px-4 py-3">Durum</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} className="p-8 text-center text-slate-500">Yükleniyor...</td></tr>}
            {!loading && filtered.length === 0 && (
              <tr><td colSpan={8} className="p-8 text-center text-slate-500">Sonuç bulunamadı.</td></tr>
            )}
            {filtered.slice(0, 500).map((r, i) => (
              <tr key={r.id} className={`border-b border-slate-200 ${i % 2 === 0 ? "bg-white" : "bg-slate-50"}`}>
                <td className="px-4 py-2 font-mono tabular-nums">{r.barcode}</td>
                <td className="px-4 py-2 font-mono">{r.order_number}</td>
                <td className="px-4 py-2 font-semibold">{r.customer_name}</td>
                <td className="px-4 py-2">{r.category} {r.model}</td>
                <td className="px-4 py-2 font-mono">{r.size}</td>
                <td className="px-4 py-2 font-mono tabular-nums">{r.product_number}/{r.product_total}</td>
                <td className="px-4 py-2 font-mono tabular-nums">{r.piece_number}/{r.piece_total}</td>
                <td className="px-4 py-2"><span className={STATUS_CHIP[r.status]}>{STATUS_LABELS[r.status]}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {filtered.length > 500 && <div className="mt-2 text-xs text-slate-500">İlk 500 sonuç gösteriliyor. Filtreleri daraltın.</div>}
    </div>
  );
}
